"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ApiProvider = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve */ const ApiProvider = (param)=>{
    let { children } = param;
    const { language } = (0, _i18n.useTranslationsWithNamespaces)();
    const { tenant } = (0, _environment.useEnvironment)();
    const { globalApiUrl, staticApiUrl } = (0, _configurationManager.useServiceUrls)([
        'globalApi',
        'staticApi'
    ]);
    const { formattedToken } = (0, _auth.useToken)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
        baseUrl: globalApiUrl,
        language: language,
        tenant: tenant,
        token: formattedToken,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_staticApiClientReact.ApiClientProvider, {
            baseUrl: staticApiUrl,
            language: language,
            tenant: tenant,
            children: children
        })
    });
};
exports.ApiProvider = ApiProvider;
